import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { NotificationListOutputModel } from '../shared/models/NotificationListOutputModel';
import { Input } from '@angular/core';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { SaveNotificationModel } from '../shared/models/SaveNotificationModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-users-notifications',
  templateUrl: './users-notifications.component.html',
  styleUrls: ['users-notifications.component.css'],
})
export class UsersNotificationsComponent implements OnInit {

  checked = true;
  disabled = false;
  notificationListModel: NotificationListOutputModel[];
  @Input() propertyId: number=0;
  saveNotifications={} as SaveNotificationModel;
  user: any;
  IsEditClick = false;
  priorityType: ILookUp[];
  previousNotification: NotificationListOutputModel[];
  constructor(private http: HttpClient, public authService: AuthenticationService, private _userManagerService: UserManagerService, private _commonService: CommonService, private _toastService: ToastService) { }
  ngOnInit() {
    this.user = this.authService.user;
    this.getPriorityItems();
    this.getAllEmailNotifications();
  }

  getAllEmailNotifications() {
    this._userManagerService.GeAllNotificationList(this.propertyId, this.user.Id).subscribe(response => {
      this.notificationListModel = response;

      if (this.notificationListModel != null && this.notificationListModel.length > 0) {
        var notCheckedList = this.notificationListModel.filter(f => f.PriorityId != 7200)
        if (notCheckedList != null && notCheckedList != undefined && notCheckedList.length > 0) {
          this.checked = true;
        }
        else {
          this.checked = false;
        }
      }
    });
  }

  onSaveNotificationClick() {
    this.saveNotifications.propertyId = this.propertyId;
    this.saveNotifications.userId = this.user.Id;
    this.saveNotifications.Notifications = this.notificationListModel;
    if (this.notificationListModel != null && this.notificationListModel != undefined) {
      this._userManagerService.saveEmailNotifications(this.saveNotifications).subscribe(response => {
        if (response) {
          this.IsEditClick = false;
          this._toastService.addToast({ title: 'Success', msg: "Notifications saved Successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
      });
    }
  }

  onEditClick() {
    this.previousNotification = structuredClone(this.notificationListModel);
    this.IsEditClick = true;
  }

  onCancelClick() {
    this.notificationListModel = structuredClone(this.previousNotification);
    if (this.notificationListModel != null && this.notificationListModel.length > 0) {
      var notCheckedList = this.notificationListModel.filter(f => f.PriorityId != 7200)
      if (notCheckedList != null && notCheckedList != undefined && notCheckedList.length > 0) {
        this.checked = true;
      }
      else {
        this.checked = false;
      }
    }
    this.IsEditClick = false;
  }

  getPriorityItems() {
    this._commonService.getLookupsByTypeId(66).subscribe(response => {
      this.priorityType = response.map(o => { return { id: o.Id, description: o.Description }; });
    });
  }

  onToggle(event: MatSlideToggleChange) {
    if (!event.checked) {
      if (this.previousNotification == null || this.previousNotification.length <= 0) {
        this.previousNotification = structuredClone(this.notificationListModel);
      }
      this.notificationListModel.forEach(item => {
        item.PriorityId = 7200;
      });
      console.log(this.previousNotification);
    } else {
      this.notificationListModel = structuredClone(this.previousNotification);
    }
  }
}
